export default {
  state: {
    currentVideoInfo: {}
  },
  mutations: {
    SET_CURRENT_VIDEO_INFO: (state, object) => {
      state.currentVideoInfo = object
    }
  },
  actions: {
    CHANGE_CURRENT_VIDEO_INFO: ({ commit }, object) => {
      commit('SET_CURRENT_VIDEO_INFO', object)
    }
  }
}
